import { queryAdminDistrictsItem } from '@/accessors/api/requests/disasterCommonAdminDistrictsApiGwFuncs'
import type { ApiConnector } from '@/types/accessor/common/connector'
import { type ArgQueryAdminDistricts } from '@/types/accessor/api/adminDistricts/adminDistricts'

export const query: ApiConnector = async (param, indexedDBConnector) => {
  const data = await queryAdminDistrictsItem(param as ArgQueryAdminDistricts)
  await indexedDBConnector(data)
  return data
}
